<template>
  <div class="content">
    <img
      v-if="$parent.showLoader"
      class="loading"
      :src="$parent.icon.loading_icon"
    >

    <div
      class="footer fixed-bottom"
      ref="BottomBox"
    >
      <div
        class="d-flex align-items-center justify-content-center flex-nowrap main-station"
        v-on:click="$parent.swapContent()"
      >
        <img
          class="menu"
          :src="$parent.icon.fav_icon"
          style="width:19px;"
        >
        <div style="margin-left: 18px;">
          {{ $t('message.favorite.title') }}
        </div>
        <div
          v-if="!is_desktop"
          class="position-absolute"
          style="right: 16px;"
        >
          <img
            v-if=$parent.showContentDetails
            class="arrow"
            :src="$parent.icon.expand_icon"
          >
          <img
            v-else
            class="arrow"
            :src="$parent.icon.less_icon"
          >
        </div>
      </div>

      <div
        class="detail-station"
        v-bind:class="{active:$parent.showContentDetails}"
        v-if="$parent.favorite_results.length > 0"
      >
        <div class="detail-station-content p-0">
          <div
            v-bind:class="[{'d-none':!$parent.showContentDetails}]"
            v-for="(place, index) in $parent.favorite_results"
            :key="(place, index)"
          >
            <div
              class="details cursor d-flex"
              v-bind:class="[{'d-none':delete_index.includes(index)}]"
              style="border-bottom: 1px solid #EBEBEB;"
            >
              <div class="pin-color pr-0 pr-3">
                <img
                  height="24"
                  :src="$parent.icon.time_gray_icon"
                >
              </div>
              <div class="text-left stackem flex-grow-1 pr-2">
                <!-- <longpress
                  v-if="is_desktop"
                  :value="place.id"
                  duration="5"
                  :on-confirm="confirmDelete"
                  :pressing-text=place.name
                  :action-text=place.name
                >
                  <div class="place-name">
                    {{ place.name }}
                  </div>
                  <div class="place-detail">
                    {{ place.address }}
                  </div>
                </longpress> -->
                <div v-on:click="getFavDetail(place)">
                  <div
                    class="place-name"
                    :title="$i18n.messages[$i18n.locale].message.click_detail"
                  >
                    {{ place.name }}
                  </div>
                  <div
                    class="place-detail"
                    v-html="place.address"
                  >

                  </div>
                </div>
              </div>
              <div
                class="my-auto pl-0"
                v-on:click="getRouting(place, index)"
              >
                <img
                  height="24"
                  :src="icon.navi_icon"
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="detail-station"
        v-bind:class="{active:$parent.showContentDetails}"
        v-else
      >
        <div class="detail-station-content p-0">
          <div v-bind:class="[{'d-none':!$parent.showContentDetails}]">
            <div class="row details px-4 pb-0 m-auto">
              <h5
                class="m-auto py-2 pin-color"
                v-if="!$parent.showLoader"
              >
                {{ $t('message.favorite.no_results_msg') }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Longpress from 'vue-longpress'
import { mapActions } from 'vuex';

export default {
  components: {
    longpress: Longpress,
  },
  name: 'Favorites',
  data () {
    return {
      is_desktop: this.$parent.isDesktop(),
      delete_index: [],
      icon: {
        navi_icon: require('@/assets/icon/ic_navigation.png'),
      },
      list_marker: [],
    }
  },
  methods: {
    ...mapActions({
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
    }),
    mapInit () {
      let scope = this

      scope.$parent.mapInit()
      scope.$parent.map.Overlays.clear()

      scope.$parent.map.Event.bind('overlayClick', scope.onFavoritePinClick)
    },
    onFavoritePinClick(overlay) {
      if (this.list_marker.includes(overlay)) {
        try {
          this.getFavDetail(JSON.parse(overlay.favorite))
        } catch (err) {
          console.log(err)
        }
      }
    },
    pinFavorite () {
      let scope = this
      var bound_list = []
      scope.list_marker = []
      scope.$parent.map.Overlays.clear()

      if (scope.$parent.currentLocation != null) {
        bound_list.push(scope.$parent.currentLocation)
      }

      scope.$parent.favorite_results.forEach(function (item, idx) {
        var marker = new longdo.Marker(item.location,
          {
            title: item.name,
            icon: {
              // html: '<img class="pin" src=' + scope.$parent.icon.pin_fav + '>',
              urlHD: scope.$parent.icon.pin_fav,
              offset: scope.$parent.getPinOffset("favorite")
            },
            clickable: true
          })

        marker.favorite = JSON.stringify(item)

        if (scope.delete_index.indexOf(idx) == -1) {
          scope.list_marker.push(marker)
          scope.$parent.map.Overlays.add(marker)
          bound_list.push(item.location)
        }
      })

      scope.$parent.mapBound(bound_list)
      scope.$parent.showMyLocation()
    },
    confirmTouchDelete (param) {
      let scope = this
      return function (direction, event) {
        console.log(direction, param);
        scope.confirmDelete(param)
      }
    },
    confirmDelete (idx) {
      if (confirm('ยืนยันการลบรายการชื่นชอบนี้?')) {
        console.log('delete ' + idx)
        this.deleteFavorite(idx)
      }
    },
    async deleteFavorite (idx) {
      let scope = this

      // WS-112
      var url = process.env.API_URL + '/front/user/favorite/delete'
      const data = {
        'id': idx,
      }
      this.showLoading()

      const apiResult = await this.Api.Call({
        method: 'POST',
        path: url,
        data: data,
      });

      scope.getFavorites()
      this.hideLoading()
    },
    getFavDetail (place) {
      place.lat = place.location.lat
      place.lon = place.location.lon

      this.$router.push({ name: 'Place', params: { data: place, isFavorite: true } })
    },
    getRouting (place) {
      this.$router.push({ name: 'SearchRoute', params: { data: { name: place.name, lon: place.location.lon, lat: place.location.lat } } })
    },
    matchHeight () {
      this.$parent.matchHeight()
    }
  },
  updated: function () {
    this.matchHeight()
  },
  mounted () {
    if (!this.$parent.is_login) {
      this.$router.replace({ name: 'Login' })
    }

    this.$parent.isHideSearch = false
    this.$parent.showContent()
    this.$parent.close()

    this.mapInit()
    this.pinFavorite()
  },
  // hook
  beforeRouteLeave (to, from, next) {
    const map = this.$parent.map
    map.Event.unbind('overlayClick', this.onFavoritePinClick)
    next()
  }
}
</script>

<style scoped>
.details {
  padding: 10px 15px;
}
</style>
